/* ==========================================================================
   Oh!My Snacks · comportamento global do sistema .ohm
   --------------------------------------------------------------------------
   Carrega com o header, portanto em todas as páginas. É a fatia do JavaScript
   do protótipo (`oh-my-brand/site/homepage/index.html`) que serve o header, o
   painel de telemóvel e o rodapé — tudo o que não é o corpo da homepage vive
   no `oms-home.js`, que só a homepage carrega.

   Quatro coisas, e mais nada:
     1. o header que assenta ao rolar
     2. o painel de menu do telemóvel
     3. as entradas `.sobe`, que o rodapé também usa
     4. o número do saco, que não vem do protótipo

   O que mudou em relação ao protótipo, e porquê:
   · O `nav.classList.toggle('fixa', scrollY > 40)` vivia dentro do `desenhar()`
     das cenas dos passos, que só existe na homepage. Passou para aqui, com
     ouvinte próprio, senão o header ficava transparente em todas as outras
     páginas do site.
   · O protótipo é uma página só e podia assumir que há sempre um hero por
     baixo do header. Aqui não há: o `data-sobre-hero` diz-nos se há, e sem ele
     o header nasce assente. Creme sobre creme não se lê.
   · O `data-sobre-cabeca` é o outro caso em que nasce solto: a loja, os
     contactos e o carrinho, que abrem numa cabeça âmbar. Assenta da mesma
     maneira; a letra escura é do CSS (ver o `oms-ohm-preambulo.css`).
   ========================================================================== */
(function () {
  var reduz = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. navegação que assenta ---------- */
  var nav = document.querySelector('.ohm-nav');
  if (nav) {
    var solto = nav.dataset.sobreHero === 'true' || nav.dataset.sobreCabeca === 'true';
    var assentar = function () {
      nav.classList.toggle('fixa', !solto || window.scrollY > 40);
    };
    addEventListener('scroll', assentar, { passive: true });
    addEventListener('resize', assentar);
    assentar();
  }

  /* ---------- 2. menu em telemóvel ---------- */
  /* Abre e fecha, e fecha com Escape ou ao escolher um destino. Verbatim do
     protótipo, só com os seletores por classe em vez de por id: o header é uma
     secção do tema e pode ser reinstanciado pelo editor, e dois elementos com
     o mesmo id não são HTML válido. */
  (function () {
    var bt = document.querySelector('.ohm-nav .menu-bt');
    var painel = document.querySelector('.ohm-painel');
    if (!bt || !painel) return;
    function por(aberto) {
      document.body.classList.toggle('menu-aberto', aberto);
      bt.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      painel.setAttribute('aria-hidden', aberto ? 'false' : 'true');
    }
    bt.addEventListener('click', function () {
      por(!document.body.classList.contains('menu-aberto'));
    });
    painel.querySelectorAll('a, .cta').forEach(function (a) {
      a.addEventListener('click', function () { por(false); });
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') por(false); });
    addEventListener('resize', function () { if (innerWidth > 960) por(false); });
  })();

  /* ---------- 3. entradas ---------- */
  /* O protótipo observava `.sobe, .risca, .zoom, .caixa` em todo o documento.
     Aqui limita-se às raízes `.ohm`, para não andar a pôr a classe `dentro` em
     elementos do Sense que por acaso se chamem `.caixa`. O rodapé precisa
     disto em todas as páginas: o selo "Take it personally." entra assim. */
  var alvos = document.querySelectorAll(
    '.ohm .sobe, .ohm .risca, .ohm .zoom, .ohm .caixa'
  );
  if ('IntersectionObserver' in window && !reduz) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dentro'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    alvos.forEach(function (el) { io.observe(el); });
  } else {
    alvos.forEach(function (el) { el.classList.add('dentro'); });
  }

  /* ---------- 4. o número do saco ---------- */
  /* O servidor desenha o número com que a página abre; isto acerta-o depois de
     cada escrita no carrinho. Não chega ouvir o `cartUpdate` do tema: só a ficha
     o publica, e o quiz, a app de upsell e a gaveta escrevem no carrinho por
     `fetch` próprio sem avisar ninguém. O que todos têm em comum é o pedido a
     `/cart/add|change|update|clear`, e esse vê-se na Resource Timing sem mexer
     no `fetch` de ninguém. A cada um relê-se o `/cart.js`, que é a verdade: o
     que um `add.js` devolve é só a linha acrescentada.
     O `pageshow` apanha o botão de voltar, que traz a página da cache do
     browser com o número de quando se saiu dela. */
  (function () {
    var saco = document.querySelector('.ohm-nav a.saco');
    var num = saco && saco.querySelector('.contador');
    if (!num) return;
    var d = saco.dataset;
    var ESCRITA = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var espera;

    function por(n) {
      num.textContent = n > 99 ? '99+' : String(n);
      num.hidden = n < 1;
      saco.setAttribute('aria-label', n < 1 ? d.rotulo
        : d.rotulo + ', ' + (n === 1 ? d.um : d.varios.replace('2', n)));
    }
    function reler() {
      clearTimeout(espera);
      espera = setTimeout(function () {
        fetch(saco.getAttribute('href') + '.js',
              { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) { if (c && typeof c.item_count === 'number') por(c.item_count); })
          .catch(function () {});
      }, 120);
    }

    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (lista) {
          if (lista.getEntries().some(function (e) { return ESCRITA.test(e.name); })) reler();
        }).observe({ entryTypes: ['resource'] });
      } catch (e) {}
    }
    addEventListener('pageshow', function (e) { if (e.persisted) reler(); });
  })();
})();
